import { render, staticRenderFns } from "./annotation-screen-shimmer.vue?vue&type=template&id=653a2b70&scoped=true"
import script from "./annotation-screen-shimmer.vue?vue&type=script&lang=js"
export * from "./annotation-screen-shimmer.vue?vue&type=script&lang=js"
import style0 from "./annotation-screen-shimmer.vue?vue&type=style&index=0&id=653a2b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a2b70",
  null
  
)

export default component.exports